import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import { SEO } from '../components/SEO';
import { getApiBase } from '../lib/apiBase';


const API_URL = getApiBase();

export const NewsletterVerify = () => {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (!token) { setStatus('error'); return; }
    fetch(`${API_URL}/api/newsletter/verify/${token}`)
      .then(r => { if (r.ok) setStatus('success'); else if (r.status === 410) setStatus('expired'); else setStatus('error'); })
      .catch(() => setStatus('error'));
  }, [token]);

  return (
    <div className="min-h-screen pt-16 flex items-center justify-center px-4" style={{ fontFamily: 'IBM Plex Sans,sans-serif' }}>
      <SEO title="Confirm Subscription | Durable Designs" path="/engineering/newsletter/verify" />
      <div className="text-center max-w-md" data-testid="newsletter-verify-page">
        {status === 'loading' && <Loader2 className="w-10 h-10 text-emerald-600 animate-spin mx-auto mb-4" />}
        {status === 'success' && (
          <>
            <CheckCircle className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Plus Jakarta Sans,sans-serif' }}>Subscription Confirmed</h1>
            <p className="text-sm text-gray-500 mb-6">You will now receive notifications when new articles are published.</p>
            <Link to="/engineering/knowledge" className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 text-sm font-medium tracking-wide transition-colors" data-testid="verify-back-link">
              Back to Knowledge
            </Link>
          </>
        )}
        {status === 'expired' && (
          <>
            <XCircle className="w-12 h-12 text-amber-500 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Plus Jakarta Sans,sans-serif' }}>Link Expired</h1>
            <p className="text-sm text-gray-500 mb-6">This confirmation link has expired. Please subscribe again.</p>
            <Link to="/engineering/knowledge" className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 text-sm font-medium tracking-wide transition-colors">
              Back to Knowledge
            </Link>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Plus Jakarta Sans,sans-serif' }}>Invalid Link</h1>
            <p className="text-sm text-gray-500 mb-6">This confirmation link is invalid or has already been used.</p>
            <Link to="/engineering/knowledge" className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 text-sm font-medium tracking-wide transition-colors">
              Back to Knowledge
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default NewsletterVerify;
